export default function Banner() {
  return (
    <div className="fixed flex justify-center items-center text-white inset-0 w-full text-center h-12 bg-blue-950">
      <span>
        👉👉 Interested in building AI applications? Contact us at{' '}
        <a
          className="underline"
          href="https://koana-labs.com"
          target="_blank"
          rel="noreferrer"
          title="Koana Labs: AI systems and custom software"
        >
          Koana Labs
        </a>{' '}
        👈👈
      </span>
    </div>
  );
}
